export enum TipoEnviosEnum {
  ALEGACIONS = 'ALEGACIONS',
  DENUNCIA = 'DENUNCIA',
  RECURS = 'RECURS',
  SANCIO = 'SANCIO'
  }